module.exports = __webpack_public_path__ + "static/media/M17A.6a7f6aab.png";